export const EnvConstants = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
  ENV: process.env.REACT_APP_ENV || "development",
} as const
